// extracted by mini-css-extract-plugin
export default {"grid":"style_grid__YU5Zo","gridContent":"style_gridContent__tlmWw","goBackAbsolute":"style_goBackAbsolute__gvF36","goBack":"style_goBack__Pz6x-","pushTop":"style_pushTop__LX1wX"};